import { ConcreteEncodable } from "./ConcreteEncodable";

import { BlotterDefinitionDeleteRequestImplEncoder } from "../../encoder/BlotterDefinitionDeleteRequestImplEncoder";

import * as CubiqTS from "../../index";
import { BlotterDefinitionDeleteRequest } from "../BlotterDefinitionDeleteRequest";

export class BlotterDefinitionDeleteRequestImpl
  extends ConcreteEncodable
  implements BlotterDefinitionDeleteRequest
{
  public static enType: string = "com.bcdfx.model.event.BlotterDefinitionDeleteRequestImpl";

  /*FID=1*/
  public blotterIds: Array<CubiqTS.Long> | null = null;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BlotterDefinitionDeleteRequestImplEncoder.Instance;
    this.setEncodableType(BlotterDefinitionDeleteRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "BlotterDefinitionDeleteRequestImpl[" +
      "blotterIds=" +
      this.blotterIds +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
